import axios from "axios";
import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import Share from "../../Assets/Images/share.png";
import ShareB from "../../Assets/Images/ShareB.png";
import SharePost from "../SharePost";
import {useI18n} from "../../i18n";
import getFormatCount from "../../CustomHelper/getFormatCount";

const PostReaction = ({ post }) => {
  const parseId = parseInt(localStorage.getItem("auth_id"));

  const [isShare, setIsShare] = useState(false);

  const [likerId, setLikerId] = useState();
  const [isLiked, setIsLiked] = useState();
  const [likeCount, setLikeCount] = useState();
  const [shareCount, setShareCount] = useState();
  const { t } = useI18n();

  function handlePost(data, postId) {
    if (data?.includes(parseId) === true) {
      const checked_data = data.filter((item) => item !== parseId);
      handleChange(checked_data, postId);
    } else {
      handleChange([...data, parseId], postId);
    }
  }

  const moveData = (data) => {
    // setShareCount(Number(Number(shareCount) + Number(data)));
  };

  function handleClick(postId, action) {
    if (localStorage.getItem("auth_token")) {
      if (action == 1) {
        setLikeCount(likeCount + 1);
        setIsLiked(true);
      } else {
        setLikeCount(likeCount - 1);
        setIsLiked(false);
      }

      handlePost(likerId, postId);
    } else {
      swal("Warning", "You'll have to Login", "warning");
    }
  }

  function shareHandler() {
    if (localStorage.getItem("auth_token")) {
      setIsShare(!isShare);
    } else {
      swal("Warning", "You'll have to Login", "warning");
    }
  }

  function handleChange(data, postId) {
    const formData = new FormData();
    setLikerId(data);

    formData.append("showlike", JSON.stringify(data));

    axios.post(`/api/submit_react/${postId}`, formData).then((res) => {
      if (res.status === 200) {
      }
    });
  }

  useEffect(() => {
    setLikerId(JSON.parse(post?.user_like_id));
    setShareCount(post?.share_count);
    JSON.parse(post?.user_like_id)?.includes(parseId)
      ? setIsLiked(true)
      : setIsLiked(false);
    setLikeCount(JSON.parse(post?.user_like_id ?? '[]')?.length + post?.love_react_count);
  }, [post, parseId]);

  return (
    <>
      <div className="d-flex justify-content-between PostGV">
        <div className="col-md-6">
          <li className="like-post">
            {likeCount === 0 ? null : (
              <>
                <i className="fas fa-heart heart mx-1 "></i>
                <small className="profile-card-text">{getFormatCount(likeCount)}</small>
              </>
            )}
          </li>
        </div>
        <div className="col-md-6">
          <li className="share-post">
            {shareCount === 0 ? null : (
              <>
                <img src={Share} alt="" width="15" /> &nbsp;
                <small className="profile-card-text">{shareCount} {t('Shares_Text')}</small>
              </>
            )}
          </li>
        </div>
      </div>
      <div className=" LikedBg px-4">
        <div className="di">
          {isLiked ? (
            <button
              className="BtnD py-2 border-0"
              onClick={() => handleClick(post.id, 0)}
            >
              <i className="fas fa-heart mx-1 text-danger"></i>
              <small className="Post-Title-home"> {t('Loved_text')} </small>
            </button>
          ) : (
            <button
              className="BtnD py-2 border-0"
              onClick={() => handleClick(post.id, 1)}
            >
              <i className="fas fa-heart mx-1 text-light"></i>
              <small className="Post-Title-home">{t('Love_Text')}  </small>
            </button>
          )}
        </div>
        <div className="di">
          <button className="BtnD py-2 border-0" onClick={shareHandler}>
            <img src={ShareB} width="20" alt="" />
            &nbsp;
            <small className="Post-Title-home">{t('Share_Text')}</small>
          </button>
          {isShare ? (
            <div className="sharePostMainDiv">
              <SharePost
                postId={post.id}
                type="postshare"
                onMoveData={moveData}
                onShare={setShareCount}
                closeShare={() => setIsShare(false)}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default PostReaction;